import { Alert, AlertTitle } from '@material-ui/lab';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './Events.css';
import { useHistory } from 'react-router-dom';
import UpcomingHealthCamps from './UpcomingHealthCamps';
import UpcomingPharmaEvents from './UpcomingPharmaEvents';
import UpcomingSportEvents from './UpcomingSportEvents';
import { Helmet } from 'react-helmet';
import { getAllHealthCampsDocument } from '../Backend/firebase/health-camps';
import { getAllPharmaEventsDocument } from '../Backend/firebase/pharma-events';
import { getAllSportEventDocument } from '../Backend/firebase/sport-event';
import { getAllEmployerDocumentWithCity } from '../Backend/firebase/user';
import { pushHealthCampsEventRecords, selectHealthCampsEventRecords, pushPharmaEventRecords, selectPharmaEventRecords, pushHealthySportsEventRecords, selectHealthySportsEventRecords } from '../DataStore/Slices/eventSlice';
import { selectCityName } from '../DataStore/Slices/citySlice';

function Events() {
    const history = useHistory();
    const dispatch = useDispatch();
    const healthCampsEventRecords = useSelector(selectHealthCampsEventRecords);
    const pharmaEventRecords = useSelector(selectPharmaEventRecords);
    const healthySportsEventRecords = useSelector(selectHealthySportsEventRecords);
    const cityName = useSelector(selectCityName);


    const getHealthCamps = async () => {
        try {
            let getAllHealthCamps = [];
            if(cityName?.city) {
                const getAllSports = await getAllHealthCampsDocument();
                const getRetailer = await getAllEmployerDocumentWithCity(cityName?.city);
                getAllSports?.map((productDoc) => {
                    const userId = productDoc.userId;
                    getRetailer?.map((retailerDoc) => {
                        if(retailerDoc.uid == userId) {
                            let objRecord = {}
                            Object.assign(objRecord, productDoc,  {storeName: retailerDoc.storeName, storeAddress: retailerDoc.storeAddress, storeCity: retailerDoc.storeCity})
                            getAllHealthCamps.push(objRecord)
                        }
                    });
                });
            } else {
                getAllHealthCamps = await getAllHealthCampsDocument();
            }
            dispatch(pushHealthCampsEventRecords({
                events: getAllHealthCamps
            }));
        } catch(error) {
            console.log("Home Screen Error Occur in Get All Health Camps ", error)
        }
    };

    useEffect(async () => {
        if (!healthCampsEventRecords) {
            await getHealthCamps();
        }
    }, [healthCampsEventRecords, cityName?.city]);

    const getPharmaEvents = async () => {
        try {
            let getAllPharmaEvents = [];
            if(cityName?.city) {
                const getAllSports = await getAllPharmaEventsDocument();
                const getRetailer = await getAllEmployerDocumentWithCity(cityName?.city);
                getAllSports?.map((productDoc) => {
                    const userId = productDoc.userId;
                    getRetailer?.map((retailerDoc) => {
                        if(retailerDoc.uid == userId) {
                            let objRecord = {}
                            Object.assign(objRecord, productDoc,  {storeName: retailerDoc.storeName, storeAddress: retailerDoc.storeAddress, storeCity: retailerDoc.storeCity})
                            getAllPharmaEvents.push(objRecord)
                        }
                    });
                });
            } else {
                getAllPharmaEvents = await getAllPharmaEventsDocument();
            }
            dispatch(pushPharmaEventRecords({
                events: getAllPharmaEvents
            }));
        } catch(error) {
            console.log("Home Screen Error Occur in Get All Health Camps ", error)
        }
    };

    useEffect(async () => {
        if (!pharmaEventRecords) {
            await getPharmaEvents();
        }
    }, [pharmaEventRecords, cityName?.city]);

    const getSportsEvents = async () => {
        try {
            let getAllSportsEvents = [];
            if(cityName?.city) {
                const getAllSports = await getAllSportEventDocument();
                const getRetailer = await getAllEmployerDocumentWithCity(cityName?.city);
                getAllSports?.map((productDoc) => {
                    const userId = productDoc.userId;
                    getRetailer?.map((retailerDoc) => {
                        if(retailerDoc.uid == userId) {
                            let objRecord = {}
                            Object.assign(objRecord, productDoc,  {storeName: retailerDoc.storeName, storeAddress: retailerDoc.storeAddress, storeCity: retailerDoc.storeCity})
                            getAllSportsEvents.push(objRecord)
                        }
                    });
                });
            } else {
                getAllSportsEvents = await getAllSportEventDocument();
            }
            dispatch(pushHealthySportsEventRecords({
                events: getAllSportsEvents
            }));
        } catch(error) {
            console.log("Home Screen Error Occur in Get All Sports Events ", error)
        }
    };

    useEffect(async () => {
        if (!healthySportsEventRecords) {
            await getSportsEvents();
        }
    }, [healthySportsEventRecords, cityName?.city]);

    useEffect(() => {
        history.push('/events');
    }, []);

    const routeOnPageByMedicalEvents = (uniqueId) => {
        history.push(`/medical-details/${uniqueId}`);
    }

    const routeOnPageBySportEvents = (uniqueId) => {
        history.push(`/sport-details/${uniqueId}`);
    }

    return (
        <>
            <div className="container-fluid event-grid">
                <Helmet>
                    <meta name="description" content="Please contact us using this form if you face any problem. Our team will help you in any case..." />
                    <title>Events | Kaipsool Pharmatech</title>
                </Helmet>
                {(healthCampsEventRecords && healthCampsEventRecords.events.length > 0) ? <div className="row">
                    <div className="col-md-10 mx-auto about__us text-left">
                        <div className="col-md-12 text-left homeScreen__topSkillsHeading">
                            <span>Health Camps</span>
                        </div>
                    </div>

                    <div className="col-md-10 md-offset-2 mx-auto about__us__row">
                        <div className="row mr-5">
                            {healthCampsEventRecords.events.map(data => (
                                <UpcomingHealthCamps 
                                    key={data.uniqueId} 
                                    Id={data.uniqueId} 
                                    Image={data.eventImage}
                                    Title={data.eventName}
                                    Type={data.eventType}
                                    EventDate={data.eventDate}
                                    EventTime={data.eventTime}
                                    Location={data.location}
                                    Organizer={data.organizer}
                                    RegistrationClosingDate={data.registrationClosingDate}
                                    routeOnPage={() => routeOnPageByMedicalEvents(data.uniqueId)} />
                            ))}
                        </div>
                    </div>
                </div> : '' }
                
                {(healthySportsEventRecords && healthySportsEventRecords.events.length > 0) ? <div className="row">
                    <div className="col-md-10 mx-auto text-left">
                        <div className="col-md-12 text-left homeScreen__topSkillsHeading">
                            <span>Healthy Sports Events</span>
                        </div>
                    </div>

                    <div className="col-md-10 md-offset-2 mx-auto about__us__row mt-3">
                        <div className="row mr-5">
                            {healthySportsEventRecords.events.map(data => (
                                <UpcomingSportEvents 
                                    key={data.uniqueId} 
                                    Id={data.uniqueId} 
                                    Image={data.eventImage}
                                    Title={data.tournamentName}
                                    Type={data.eventCategory}
                                    StartDate={data.startDate}
                                    EndDate={data.endDate}
                                    Location={data.location}
                                    OrganizerName={data.organizerName}
                                    RegistrationClosingDate={data.registrationClosingDate}
                                    routeOnPage={() => routeOnPageBySportEvents(data.uniqueId)} />
                            ))}
                        </div>
                    </div>
                </div> : ''}
                
                {(pharmaEventRecords && pharmaEventRecords.events.length > 0) ? <div className="row">
                    <div className="col-md-10 mx-auto text-left">
                        <div className="col-md-12 text-left homeScreen__topSkillsHeading">
                            <span>Pharma Events</span>
                        </div>
                    </div>

                    <div className="col-md-10 md-offset-2 mx-auto about__us__row mt-3">
                        <div className="row mr-5">
                            {pharmaEventRecords.events.map(data => (
                                <UpcomingPharmaEvents 
                                    key={data.uniqueId} 
                                    Id={data.uniqueId} 
                                    Image={data.eventImage}
                                    Title={data.eventName}
                                    Type={data.eventType}
                                    EventDate={data.eventDate}
                                    EventTime={data.eventTime}
                                    Location={data.location}
                                    Organizer={data.organizer}
                                    RegistrationClosingDate={data.registrationClosingDate}
                                    routeOnPage={() => routeOnPageByMedicalEvents(data.uniqueId)}  />
                            ))}
                        </div>
                    </div>
                </div> : ''}
            </div>
        </>
    )
}

export default Events
